(function () {
  if (window.EnviroBuildAttribution) return;

  function getCookie(name) {
    try {
      var match = document.cookie.match(
        new RegExp("(?:^|;\\s*)" + name + "=([^;]+)")
      );
      return match ? decodeURIComponent(match[1]) : "";
    } catch (e) {
      return "";
    }
  }

  function getStoredRecord(name) {
    try {
      var raw = localStorage.getItem("vl_" + name);
      if (!raw) return null;

      var record = JSON.parse(raw);

      if (
        record &&
        record.value &&
        record.expiry &&
        Date.now() < record.expiry
      ) {
        return record;
      }
    } catch (e) {}

    return null;
  }

  function get(name) {
    var record = getStoredRecord(name);

    if (record) {
      return String(record.value);
    }

    return getCookie("vl_" + name);
  }

  window.EnviroBuildAttribution = {
    get: get,

    getAll: function () {
      return {
        gclid: get("gclid"),
        gbraid: get("gbraid"),
        wbraid: get("wbraid"),
        utm_source: get("utm_source"),
        utm_medium: get("utm_medium"),
        utm_campaign: get("utm_campaign"),
        utm_content: get("utm_content"),
        utm_term: get("utm_term")
      };
    }
  };
})();